/* eslint-disable @typescript-eslint/no-explicit-any */
import "react-toastify/dist/ReactToastify.css";
import qs from "qs";
import { IResponseListSSOProviders } from "../../interfaces/SSOProviders";
import { IListParams } from "@/interfaces/serviceInterface";
import { api } from "../api/httpClient"; // <- evita ciclos via barrel "@/services"
import { useQuery, useQueryClient } from "@tanstack/react-query";

const BASE = "/ssoproviders";

// serializer padrão (arrays em brackets, ignora null/undefined)
const serialize = (p: any) =>
  qs.stringify(p, { arrayFormat: "brackets", skipNulls: true, encode: true });

/* ========= Função pura (API) ========= */
export async function listSSOProviders(params: Partial<IListParams> = {}) {
  const { filter, includes, page, limit, select } = params;
  const { data } = await api.get<IResponseListSSOProviders>(BASE, {
    params: { filter, includes, page, limit, select },
    paramsSerializer: (p) => serialize(p),
  });
  return data;
}

/* ========= Query Keys ========= */
export const ssoKeys = {
  all: ["ssoProviders"] as const,
  // usa um sufixo 'default' estável quando nenhum parametro for passado
  list: (params?: Partial<IListParams>) =>
    [...ssoKeys.all, "list", params ?? "default"] as const,
};

/* ========= Hook (React Query) ========= */
export function useSSOProviders(
  opts?: { enabled?: boolean; staleTimeMs?: number; params?: Partial<IListParams> }
) {
  const { enabled = true, staleTimeMs = 60 * 60 * 1000, params } = opts ?? {};
  return useQuery({
    queryKey: ssoKeys.list(params),
    queryFn: () => listSSOProviders(params ?? {}),
    staleTime: staleTimeMs,       // 60 min "fresh"
    gcTime: 2 * 60 * 60 * 1000,   // 2h no cache
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled,
  });
}

/* ========= Prefetch opcional ========= */
export function prefetchSSOProviders(
  qc: ReturnType<typeof useQueryClient>,
  params?: Partial<IListParams>,
  staleTimeMs = 60 * 60 * 1000
) {
  return qc.prefetchQuery({
    queryKey: ssoKeys.list(params),
    queryFn: () => listSSOProviders(params ?? {}),
    staleTime: staleTimeMs,
  });
}
